import * as React from 'react';

import { cn } from '#/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  theme?: 'light' | 'dark';
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, theme, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'form-input',
          className,
          theme === 'dark' && 'form-input-dark',
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';

export { Input };
